import { FlightCard } from "@/src/types/flight"
import { KeyboardArrowRight } from "@mui/icons-material"
import { Box, Stack, Typography } from "@mui/material"
import { SelectedOnwardLegFlightInfo } from "../selectedOnwardLegFlightInfo"

export const TabItem = ({ isActive, handleClick, isOnward, onwardFlightData, route, tCommon, isArabic, selectedLeg

}: {
    isActive: boolean
    isOnward: boolean
    handleClick: (e: React.MouseEvent<HTMLDivElement>) => void
    tCommon: (key: string) => string
    onwardFlightData: FlightCard | null
    route: string
    selectedLeg: number
    isArabic: boolean
}) => {
    return (
        <>
            <Stack flex={1} borderBottom={isActive ? "2px solid #000" : "none"} py={0.5} onClick={isOnward ? handleClick : undefined}>
                <Typography
                    fontSize={10}
                    fontWeight={600}
                    color={isActive ? '#000' : "textDisabled"}
                    textTransform={"uppercase"}
                >
                    {isOnward ? tCommon('onward') : tCommon('return')}
                </Typography>
                {onwardFlightData && isOnward ? <SelectedOnwardLegFlightInfo onwardFlightData={onwardFlightData} /> : <Typography fontSize={12} fontWeight={500} color={isActive ? '#000' : 'textDisabled'}>
                    {route}
                </Typography>}
            </Stack>
            {isOnward && (
                <Box>
                    <KeyboardArrowRight color={selectedLeg === 1 ? "inherit" : "disabled"} sx={{ transform: isArabic ? "rotate(180deg)" : "none" }} />
                </Box>
            )}


        </>
    )
}
